// TODO add graphql query - make it dynamic
export const properties = ['hayu.com'] as string[];

export default properties;
